import {css, Theme} from "@emotion/react";
import {Loader} from "@pg-design/loader";
import {Text} from "@pg-design/text";

import {MapRegionSearchOption} from "../utils/map_region_search_option";
import {
    MapRegionOptionRow,
    mapRegionOptionsList,
    mapRegionOptionsSection,
    mapRegionOptionsSectionTitle
} from "./MapRegionOptionRow";

type MapRegionOptionsSectionProps = {
    title: string;
    options: MapRegionSearchOption[];
    onSelect: (option: MapRegionSearchOption) => void;
    isLoading?: boolean;
    emptyMessage?: string;
};

export const MapRegionOptionsSection = ({
    title,
    options,
    onSelect,
    isLoading = false,
    emptyMessage
}: MapRegionOptionsSectionProps) => (
    <div css={mapRegionOptionsSection}>
        <Text variant="mini_header" css={mapRegionOptionsSectionTitle} as="p">
            {title}
        </Text>

        {isLoading ? (
            <div css={loader}>
                <Loader size="sm" />
            </div>
        ) : options.length === 0 && emptyMessage ? (
            <div css={empty}>{emptyMessage}</div>
        ) : (
            <ul css={mapRegionOptionsList} role="listbox" aria-label={title}>
                {options.map((option, index) => (
                    <MapRegionOptionRow
                        key={`${option.region.id}-${option.region.slug}`}
                        title={option.label}
                        subtitle={option.subtitle}
                        isLast={index === options.length - 1}
                        onSelect={() => onSelect(option)}
                    />
                ))}
            </ul>
        )}
    </div>
);

const loader = css`
    display: flex;
    justify-content: center;
    padding: 2rem 1.5rem 2.25rem;
`;

const empty = (theme: Theme) => css`
    padding: 1rem 1.5rem 1.5rem;
    font-size: 1rem;
    color: ${theme.colors.gray[600]};
`;
